import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const slides = [
  {
    src: "/img/service/slide111.jpg",
    alt: "slide1",
    bg: "bg-[#f4f4f4]",
    title: "INCREASE YOUR MACHINE PERFORMANCE",
    description:
      "STRATUS INSTRUMENTATION PVT. LTD. has the best quality, precise masters, to fulfill your calibration needs.",
  },
  {
    src: "/img/slider2.jpg",
    alt: "slide2",
    bg: "bg-[#c7e3f5]",
    title: "ONE-STOP FOR EQUIPMENT CALIBRATION",
    description:
      "STRATUS INSTRUMENTATION PVT. LTD. has the best quality, precise masters, to fulfill your calibration needs.",
  },
];

export const HomeSlider = () => {
  const sliderSettings = {
    dots: true,
    infinite: true,
    autoplay: true,
    speed: 800,
    autoplaySpeed: 3000,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
  };

  return (
    <div className="w-full overflow-hidden">
      <Slider {...sliderSettings}>
        {slides.map((slide, idx) => (
          <div key={idx} className={`w-full  ${slide.bg}`}>
            <div className="flex flex-col md:flex-row h-[520px]">
              {/* Left: Image */}
              <div className="md:w-1/2 w-full h-1/2 md:h-full clip-angled-right">
                <img
                  src={slide.src}
                  alt={slide.alt}
                  className="w-full h-full object-cover"
                />
              </div>

              {/* Right: Angled Content */}
              <div
                className={`md:w-1/2 w-full flex items-center justify-center ${slide.bg} relative `}
              >
                {/* Content */}
                <div className="relative z-20 px-6 md:px-12 text-center md:text-left">
                  <h2 className="mt-5 text-3xl md:text-5xl font-extrabold text-purple-900 mb-4 leading-tight">
                    {slide.title}
                  </h2>
                  <br />
                  <p className="text-gray-700 text-lg md:text-xl mb-6">
                    {slide.description}
                  </p>
                 
                </div>
              </div>
            </div>
          </div>
        ))}
      </Slider>
    </div>
  );
};
